enum Brand {
  Peugeot = 'peugeot',
  Opel = 'opel',
  Citroen = 'citroen',
  DS = 'ds',
  Mitsubishi = 'mitsubishi',
  Fiat = 'fiat',
  FiatProfessional = 'fiatProfessional',
  Jeep = 'jeep',
  AlfaRomeo = 'alfaRomeo',
  Hongqi = 'hongqi',
  Voyah = 'voyah',
  Navor = 'navor',
  Leapmotor = 'leapmotor',
}

export default Brand;
